import { axios } from '../../../util/axios'

const API_ENDPOINT = '/v1/accounts/email/validate'

export default token =>
  axios
    .post(
      API_ENDPOINT,
      { token },
      {
        withCredentials: true,
      }
    )
    .then(response => response.data)
